
















import Vue from 'vue';
import IconBase from './IconBase.vue';
import IconAddWhite from './icons/IconAddWhite.vue';

export default Vue.extend({
  name: 'add-item',
  data: () => ({
    item: '',
  }),
  methods: {
    submit() {
      if (this.item === '') return;
      this.$store.commit('add', this.item);
      this.item = '';
    },
  },
  components: {
    IconBase,
    IconAddWhite,
  },
});
